export let changePassCtrl = (function (angular) {

    window.app.controller('changePassCtrl', ['$http', '$scope', '$compile', function ($http, $scope, $compile) {
        /*--------- request --------- */
        $scope.resetPassSuccess = false;

        $scope.requestSuccess = function (resp) {

            if (resp.data.requestSuccess) {
                $scope.resetPassSuccess = true;
            }
            else {
                $scope.formErrorText = resp.data.message;
                $scope.formErrorLink = resp.data.link;

            }
        }

        $scope.resetPassFromSA = () => {
            localStorage.setItem("SAData", JSON.stringify($scope.user));
            sessionStorage.setItem('orangeRange', $scope.user.costVal);
            sessionStorage.setItem('blueRange', $scope.user.durationVal);
            let ressetData = $scope.emailValue();
            ressetData.fromApplication = 1;
            $scope.withoutSave ? ressetData.emptyApplication = 1 : "";
            $scope.formErrorText = '';
            $scope.sendXHR({
                url: '/api/front/password/ask-pass/ask',
                data: ressetData,
                successFunc: $scope.requestSuccess
            });
        }

        //Should be replaced by function that check some parameter in url. Local storage shodn't contain Whitout save parametr
        $scope.checkSaveNecessity = () => {
            let fromApp = window.location.href.includes("fromApplication");
            if (fromApp) {
                document.getElementById('sa-auth-form').style.cssText = 'display: block !important';
                $(document).ready(() => {
                    $scope.scrollTo("#sa-auth-form");
                    $(".app-pre-auth").css("display", "none")
                });
            }
            $scope.emptyApplication = window.location.href.split('emptyApplication=')[1];
        }

        $scope.changePassFromSA = function () {
            $scope.formErrorText = '';
            $scope.formErrorLink = '';
            $scope.passValue.changeKey = window.location.href.split('key=')[1].split('&')[0];
            $scope.passValue.type = 'user';
            $scope.passValue.fromApplication = 1;
            $scope.sendXHR({
                url: '/api/front/password/change-pass/change?key=' + $scope.passValue.changeKey,
                data: $scope.passValue,
                successFunc: $scope.passChangedSA
            });
        }

        $scope.passChangedSA = (resp) => {
            if (resp.data.changeSuccess == true) {
                if (!$scope.emptyApplication) {
                    $scope.saveApplication();
                    localStorage.setItem("sendAtOnce", true);
                }
                $scope.redirect('/login');
            }
        }

        $scope.sendResetPassForm = function () {
            $scope.formErrorText = '';
            $scope.sendXHR({
                url: '/api/front/password/ask-pass/ask',
                data: $scope.emailValue,
                successFunc: $scope.requestSuccess
            });
        }
        /*--------- reset pass ---------*/
        $scope.changedPass = false;

        $scope.passValue = {}
        $scope.passChanged = function (resp) {
            if (resp.data.changeSuccess == true) $scope.redirect('/login');
        }

        $scope.changePass = function () {
            $scope.formErrorText = '';
            $scope.formErrorLink = '';
            $scope.passValue.changeKey = window.location.href.split('key=')[1].split('&')[0];
            $scope.passValue.type = 'user';
            $scope.sendXHR({
                url: '/api/front/password/change-pass/change?key=' + $scope.passValue.changeKey,
                data: $scope.passValue,
                successFunc: $scope.passChanged
            });
        }


        //BIK password creation
        $scope.registration = {};
        $scope.email;

        $scope.passEmail = (email) => {
            $scope.email = email;
        }

        class bikUser {
            constructor(password, accept_terms, accept_personal_data_terms, accept_mailing_policy) {
                this.password = password;
                this.accept_terms = accept_terms;
                this.accept_personal_data_terms = accept_personal_data_terms;
                this.accept_mailing_policy = accept_mailing_policy;
                this.type = 'user';
                this.changeKey = window.location.href.split('key=')[1].split('&')[0];
            }
        }

        $scope.createBikPassword = () => {
            let passwordData = new bikUser($scope.registration.password, $scope.registration.accept_terms, $scope.registration.accept_personal_data_terms, $scope.registration.accept_mailing_policy)
            $scope.formErrorText = '';
            $scope.formErrorLink = '';
            $scope.sendXHR({
                url: '/api/front/password/change-pass/change?key=' + passwordData.changeKey,
                data: passwordData,
                successFunc: $scope.userEnter
            });
        }

        $scope.userEnter = (resp) => {
            if (resp.data.changeSuccess == true) {
                $scope.sendXHR({
                    url: '/api/front/authorization/authorization/authorize',
                    data: {
                        rememberMe: false,
                        acceptTerms: $scope.registration.accept_terms,
                        acceptAdPolicy: $scope.registration.accept_personal_data_terms,
                        acceptMailingPolicy: $scope.registration.accept_mailing_policy,
                        email: $scope.email,
                        password: $scope.registration.password,
                        type: 'user'
                    },
                    successFunc: $scope.enterToOffice
                })
            }
        }

        $scope.enterToOffice = (resp) => {
            if (resp.data.authSuccess) {
                $scope.redirect(resp.data.authUrl);
            }
        }

    }]);
})(window.angular);



// WEBPACK FOOTER //
// src/js/controllers/user/changePassCtrl.js